import { get } from "@ember/object";
import { compare } from "@ember/utils";

// Copied and adapted from https://github.com/emberjs/ember.js/blob/0c59b21bb380daa491d9d9fcb1dc27fd5e56cd5d/packages/%40ember/object/lib/computed/reduce_computed_macros.ts#L1282
export default function (items, sortProperties) {
  return items.slice().sort((itemA, itemB) => {
    for (const [prop, direction] of sortProperties) {
      const result = compare(get(itemA, prop), get(itemB, prop));
      if (result !== 0) {
        return direction === "desc" ? -1 * result : result;
      }
    }
    return 0;
  });
}